import recentActivity from './recentActivity'
import alertTable from './alertTable'

export const RecentActivity = recentActivity;
export const AlertTable = alertTable;
